<script>
export default {
  title: 'Foo Page'
}
</script>
<template>
  <div class="home">
    <main role="main">
      <div class="album py-5 bg-light">
        <div class="container">
          <section class="jumbotron text-center">
            <div class="">
              <p><HelloWorld msg="" /></p>
              <h2 class="jumbotron-heading">
                <small class="text-muted">Velkommen til</small>
                Alfa Lagerhotell A/S
              </h2>

              <p class="lead text-muted">
                Et hjem for alt!  
              </p>
                                            <router-link to="/kontakt"
                  ><a  class="btn btn-sm btn-success active" role="button" aria-pressed="true">Kontakt oss i dag</a></router-link
                >
   
            </div>
          </section>
          <div class="row text-left">
<div class="card-deck">
  <div class="card">
    <img src="../assets/kort1.jpg" class="card-img-top" alt="...">
    <div class="card-body">
      <h5 class="card-title">Kort om oss</h5>
      <p class="card-text">
        
                    Alfa lagerhotell a/s er byens største og rimeligste
                    konvensjonelle lagerhotell.
                    <br />
                    <strong
                      >Skulle du mot
                      formodning finne rimeligere priser et annet sammenlignbart
                      sted, gi oss beskjed, så matcher vi denne prisen og gir
                      deg ytterligere 10%.
                    </strong>
                    <br />

      </p>

    </div>
        <div class="card-footer">
     
    </div>
  </div>
  <div class="card">
    <img src="../assets/kort2.jpg" class="card-img-top" alt="...">
    <div class="card-body">
      <h5 class="card-title">Åpningstider</h5>
      <p class="card-text">
        
                    Du har tilgang 24/7, men vi oppfordrer alle om å respektere
                    naboene og holde seg innenfor tidspunktene 0700 og 2100.
                    Lageret er alltid betjent tirsdager og torsdager mellom 17
                    og 19. Da kan du ordne med nøkkelkort, kontrakter,
                    flyttekasser, hengelåser eller hva det nå måtte være. Skulle
                    det være noe spesielt er vi aldri lenger enn en
                    telefonsamtale unna.

      </p>

    </div>
        <div class="card-footer"></div>
  </div>
  <div class="card">
    <img src="../assets/kort3.jpg" class="card-img-top" alt="...">
    <div class="card-body">
      <h5 class="card-title">Klima</h5>
      <p class="card-text">
        
                            Bodene er lokalisert i vårt store klimaregulerte lokale som
                    holder jevn temperatur hele året. Vi kjører store,
                    automatiserte luftavfuktere kontinuerlig. Dette sikrer
                    optimale forhold for lagring av alt fra frimerker til
                    rokokkomøbler og elektronikk, og ikke som i en container
                    hvor temperaturen svinger med været og skaper fukt og
                    kondens.


      </p>
      
    </div>
        <div class="card-footer">
    </div>
  </div>
</div>

          </div>


          <div class="row text-left">
<div class="card-deck">
  <div class="card">
    <img src="../assets/kort4.jpg" class="card-img-top" alt="...">
    <div class="card-body">
      <h5 class="card-title">Drive in</h5>
      <p class="card-text">
        
Du kjører bilen/hengeren helt frem til porten, hvor våre store traller gjør transporten videre frem til boden enkel og effektiv. Det er enkelt og greit å manøvrere hengeren på den store plassen foran lageret.

      </p>

    </div>
            <div class="card-footer"></div>
  </div>
  <div class="card">
    <img src="../assets/kort5.jpg" class="card-img-top" alt="...">
    <div class="card-body">
      <h5 class="card-title">Sikkerhet</h5>
      <p class="card-text">
              Du låser boden med din egen lås (har du glemt lås, kan du kjøpe en av oss), selve lageret er sikret 24/7 av Securitas Direct med utrykning. Alle inne- og uteområder er overvåket med live-kameraovervåkning. Hver kunde har sin egen unike alarmkode som registreres inn/ut.
      </p>

    </div>
            <div class="card-footer"></div>
  </div>
  <div class="card">
    <img src="../assets/kort6.jpg" class="card-img-top" alt="...">
    <div class="card-body">
      <h5 class="card-title">Fleksible leieperioder</h5>
      <p class="card-text">
        Leie løper over hele mnd, dvs at første regning blir avregnet frem til den første hele mnd. Deretter faktura fra den 1. hver mnd. Alfa lagerhotell a/s opererer med kun en mnd oppsigelsestid, gjeldende fra første hele mnd. Dette er tilstrekkelig for å kunne sikre en fornuftig logistikk.
      </p>
      
    </div>
            <div class="card-footer"></div>
  </div>
</div>

          </div>

          <div class="row text-left">
<div class="card-deck">
  <div class="card">
    <img src="../assets/kort7.jpg" class="card-img-top" alt="...">
    <div class="card-body">
      <h5 class="card-title">Forsikring</h5>
      <p class="card-text">
Du flytter innboforsikringen til vår adresse. Det er noe ulik praksis for de forskjellige forsikringsselskapene om hva de dekker når det gjelder oppbevaring. Du bør sjekke hva din innboforsikring dekker i tilfelle skade/brann og lignende når du flytter tingene dine til Knarrevikveien 60. Husk at du kun leier lokale/bod av oss, og står selv ansvarlig for at tingene i boden er tilstrekkelig forsikret.

      </p>

    </div>
            <div class="card-footer"></div>
  </div>
  <div class="card">
    <img src="../assets/kort8.jpg" class="card-img-top" alt="...">
    <div class="card-body">
      <h5 class="card-title">Bodstørrelser</h5>
      <p class="card-text">
        
Vi tilbyr boder i tre størrelser; 6,5m3, 10m3 og 17m3. Du trenger ca 1/3 av kvadratmeterne omgjort til kubikk. Erfaringsmessig regner vi at en normalt møblert leilighet på en 60 – 70 kvadratmeter får plass i en 17m3 bod, målene på denne er 190x360 cm, dvs snaue 7 kvadratmeter. Har du mye flyttekasser/løsøre og ikke så mye store møbler, så rommer en 10m3 bod utrolig mye, målene på denne er 130x320 cm, altså litt over 4 m2. 6,5m3 boden er mer kvadratisk, 150x180 og egner seg godt til det meste av kasser, løsøre og mindre møbler. Mange bruker denne eller 10 kubikkeren som ekstra bodplass for hagemøbler, sommer/vinterdekk, skiutstyr osv.
      </p>

    </div>
        <div class="card-footer"></div>
  </div>
  <div class="card">
    <img src="../assets/kort9.jpg" class="card-img-top" alt="...">
    <div class="card-body">
      <h5 class="card-title">Begrensninger
</h5>
      <p class="card-text">
Vi tillater ikke lagring av matvarer, sprengstoff, gift, sterkt luktende ting eller væsker. Dette for å hindre uhell som kan gå utover andre leietakere. Husk at om noe av innholdet i din bod skader andres ting, kan vedkommendes forsikringsselskap komme til å kreve regress av skadeforvolder.

      </p>
      
    </div>
            <div class="card-footer"></div>
  </div>
</div>

          </div>

        </div>
      </div>
    </main>
  </div>
</template>
<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "Home",
  components: {
    HelloWorld,
  },
};
</script>
